import { z } from 'zod';
import { ComplectationOption } from '@/types/complectation/complectation-option.type.ts';
import { ComplectationOptionsSchema } from '@/types/complectation/complectation-options.type.ts';

export type Complectation = {
    id: number,
    brand_id?: number,
    model_id: number,
    model_name?: string,
    brand_name?: string,
    code: string,
    created_at?: string,
    updated_by?: string,
    updated_at?: string,
    options?: ComplectationOption[],
};

export const ComplectationSchema = z.object({
    id: z.number(),
    brand_id: z.number().optional(),
    model_id: z.number(),
    model_name: z.string().optional(),
    brand_name: z.string().optional(),
    code: z.string(),
    created_at: z.string().optional(),
    updated_by: z.string().optional(),
    updated_at: z.string().optional(),
    options: ComplectationOptionsSchema.optional(),
});
